export default __webpack_public_path__ + "static/media/HTML-Tag.3218d544.jpg";